import { all, call, spawn } from "redux-saga/effects";

import classesSaga from "Store/classrooms/saga";
import instructorSaga from "Store/instructors/saga";
import locationsSaga from "Store/locations/saga";
import studentsSaga from "Store/students/saga";
import studentsLessonsSaga from "Store/students/studentsLessons/saga";
import studentsTestsSaga from "Store/students/studentsTests/saga";
import studentsWorksheetsSaga from "Store/students/studentsWorksheets/saga";
import usersSaga from "Store/user/saga";
import courseTemplatesSaga from "Store/courseTemplates/saga";
import globalSaga from "Store/global/saga";
import calendarSaga from "Store/calendar/saga";
import backgroundTasksSaga from "Store/backgroundTasks/saga";

const sagas = [
  backgroundTasksSaga,
  studentsSaga,
  studentsLessonsSaga,
  studentsWorksheetsSaga,
  studentsTestsSaga,
  instructorSaga,
  classesSaga,
  locationsSaga,
  usersSaga,
  courseTemplatesSaga,
  globalSaga,
  calendarSaga
];

export default function* rootSaga() {
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            console.warn(error);
          }
        }
      })
    )
  );
}
